<template>
  <span
      v-if="
        nomenclature &&
        nomenclature.unit_of_measurement &&
        nomenclature.unit_of_measurement.name
      "
  >
    {{
      $t(
          "goods.units_of_measurements." +
          nomenclature.unit_of_measurement.name +
          ".short"
      )
    }}
  </span>
</template>

<script>
export default {
  name: "NomenclatureMeasurementShortName",
  props: {
    nomenclature: null,
  },
}
</script>

<style scoped>

</style>